<template lang="pug"></template>

<script>
import BotaoListaArmazem from './BotaoListaArmazem.vue';

export default {
    name: 'BotaoSaldoArmazem',
    componentOptions: {
        title: 'Saldo Armazém',
        actions: [
            [
                {
                    name: 'Saldo Armazém',
                    iconClass: 'lyra-icon lyra-armazem',
                    showView: false,
                    action: 'abrirSaldoArmazem',
                    route: 'saldoArmazem',
                    submenus: [
                        BotaoListaArmazem
                    ]
                }
            ]
        ]
    },

    methods: {
        abrirSaldoArmazem() {
            if (this.$route.name !== 'saldoArmazem') {
                this.$router.push({ name: 'saldoArmazem' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
